import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import { withTranslation } from "react-i18next";
import DeleteDialog from "../../DeleteDialog";
import { authContext } from "../../../contexts/AuthContext";
import CPDeleteIconButton from "../../Utils/CPDeleteIconButton";
import CPSettingsIconButton from "../../Utils/CPSettingsIconButton";
import i18next from "i18next";

class ComplianceListItem extends React.Component {
  constructor() {
    super();
    this.state = {
      deleteCompliance: {},
    };
  }

  static contextType = authContext;

  handleDeleteComplianceOpen = (compliance) => {
    this.setState({ deleteCompliance: compliance });
  };

  handleDialogClose = () => {
    this.setState({ deleteCompliance: {} });
  };

  deleteCompliance = (compliance) => {
    compliance.loggedUserId = this.context.auth.user.id;
    compliance.brandLabel = window.$brand;
    this.props.onDelete(compliance);
  };

  render() {
    const { t, compliance, onEdit } = this.props;

    return (
      <ListItem
        divider
        secondaryAction={
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <CPSettingsIconButton onClick={() => onEdit(compliance)} />
            <CPDeleteIconButton
              onClick={() => this.handleDeleteComplianceOpen(compliance)}
            />
          </Box>
        }
      >
        <ListItemText
          primary={
            i18next.language === "es" ? compliance.name_es : compliance.name_en
          }
          secondary={
            (i18next.language === "es"
              ? compliance.description_es
              : compliance.description_en) || "-"
          }
        />

        <DeleteDialog
          item={this.state.deleteCompliance}
          title={t("delete_compliance")}
          caption={t("delete_compliance_full_caption")}
          targetFunc={this.deleteCompliance}
          handleDialogClose={this.handleDialogClose}
        />
      </ListItem>
    );
  }
}

export default withTranslation()(ComplianceListItem);
